import { Skeleton, Stack } from "@mui/material";

export default function ConfirmationSkeleton() {
  return (
    <Stack alignItems="center" spacing={1}>
      <Skeleton variant="rectangular" width={160} height={120} />
      <Skeleton variant="text" width={350} height={48} />
      <Skeleton variant="text" width={300} height={24} />
      <Skeleton variant="text" width={250} height={24} />
      <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
        <Skeleton variant="rectangular" height={50} width={350} sx={{ borderRadius: 10 }} />
        <Skeleton variant="rectangular" height={50} width={350} sx={{ borderRadius: 10 }} />
      </Stack>
    </Stack>
  );
}
